// Third-party imports
import axios from 'axios';

export async function get_collection(params) {
    params.page = params.page || 1;
    let coll = params.collection;
    let filterstr = get_filter_string(params.filters);
    let url =
        `/collections/${coll}/${filterstr}` +
        `?view=filter-endpoint&page=${params.page}`;
    let response = await axios.get(url);
    await params.cb(response.data);
}

function get_filter_string(filters) {
    let filterstr = '';
    Object.keys(filters).forEach((key, index) => {
        if (index) filterstr += '+';
        filterstr += key + ':' + filters[key];
    });
    return filterstr;
}
